const strings = {
	header: 'Hanwen Cheng\'s Website ',
};

export default strings;
